import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyCs2() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`II.`}
            <br />
            {`Uživatelský účet`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Na základě registrace uživatele provedené na webové stránce může uživatel přistupovat do svého uživatelského rozhraní (dále jen „uživatelský účet“).  `}</li>
            <li>{`Při registraci je uživatel povinen uvádět správně a pravdivě všechny údaje. Údaje uvedené v uživatelském účtu je uživatel při jakékoliv jejich změně povinen aktualizovat. Údaje uvedené uživatelem v uživatelském účtu jsou poskytovatelem považovány za správné. `}</li>
            <li>{`Přístup k uživatelskému účtu je zabezpečen uživatelským jménem a heslem. Uživatel je povinen zachovávat mlčenlivost ohledně informací nezbytných k přístupu do jeho uživatelského účtu.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={4} className={sList}>
            <li>{`Uživatel není oprávněn umožnit využívání uživatelského účtu třetím osobám.`}</li>
            <li>{`Uživatel bere na vědomí, že uživatelský účet nemusí být dostupný nepřetržitě, a to zejména s ohledem na nutnou údržbu hardwarového a softwarového vybavení poskytovatele, popř. nutnou údržbu hardwarového a softwarového vybavení třetích osob.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyCs2;
